import { render, staticRenderFns } from "./CampusModules.vue?vue&type=template&id=330e278d&scoped=true"
import script from "./CampusModules.vue?vue&type=script&lang=js"
export * from "./CampusModules.vue?vue&type=script&lang=js"
import style0 from "./CampusModules.vue?vue&type=style&index=0&id=330e278d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e278d",
  null
  
)

export default component.exports